import React, { useContext } from "react";
import { Card } from "reactstrap";

import { fetchAllPromisedData } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { getCourseDetails } from "views/pages/manage/edpOps/stockManagement/service";
import { endpoint } from "views/pages/manage/common/constant";
import APopover from "../../../../common/a-popover";

import { EyeIcon } from "../manage-receipts/EyeIcon";
import { EPMRContext } from "./context";
import { getRemarksByEpmrNumber } from "views/pages/manage/unAssigned/studentFinanceApproval/epmrCancellation/utils";

export const BUPopover = ({ businessArea, businessAreaOptions }) => {
  const { buDescriptionMap, setBuDescriptionMap } = useContext(EPMRContext);

  const [businessAreaDesc, setBusinessAreaDesc] = React.useState("");
  const [isFetching, setIsFetching] = React.useState(false);

  const getBuDesc = async () => {
    setIsFetching(true);
    const businessAreaId = businessAreaOptions?.filter(
      (bu) => bu.value === businessArea
    )[0]?.businessAreaId;

    const resp = await fetchAllPromisedData(
      `${endpoint?.businessArea.getBusinessAreaByIdV2}/${businessAreaId}`
    );

    if (resp) {
      const description = resp?.businessAreaDesc;
      setBusinessAreaDesc(description);
      setBuDescriptionMap((prev) => ({ ...prev, [businessArea]: description }));
    } else setBusinessAreaDesc("Unable to show data!");
    setIsFetching(false);
  };

  return (
    <APopover
      buttonComponent={(onClick, styles) => (
        <span
          onClick={(e) => {
            onClick(e);
            buDescriptionMap[businessArea]
              ? setBusinessAreaDesc(buDescriptionMap[businessArea])
              : getBuDesc();
          }}
          style={{ cursor: "pointer" }}
        >
          <EyeIcon />
        </span>
      )}
      menuComponent={(closeForm) => (
        <>
          <Card
            className="mb-0 regular-body label-color"
            style={{ borderRadius: "12px" }}
          >
            <div className="p-2 text-bold">
              {isFetching ? "Loading..." : businessAreaDesc}
            </div>
          </Card>
        </>
      )}
      transformOriginVertical="center"
      transformOriginHorizontal="left"
    />
  );
};

export const CourseTermPopover = ({ courseId, term }) => {
  const { courseTermMap, setCourseTermMap } = useContext(EPMRContext);
  const [courseDesc, setCourseDesc] = React.useState("");
  const [isFetching, setIsFetching] = React.useState(false);

  const fetchCourseName = async () => {
    setIsFetching(true);
    if (courseId) {
      const res = await getCourseDetails(courseId);
      if (res?.code === 200 && res?.data) {
        const description = res?.data[0].courseName;
        setCourseDesc(description);
        setCourseTermMap((prev) => ({
          ...prev,
          [courseId]: description,
        }));

        setIsFetching(false);

        return;
      }
    }
    setCourseDesc("-");
    setCourseTermMap((prev) => ({
      ...prev,
      [courseId]: "-",
    }));
    setIsFetching(false);
  };

  return (
    <APopover
      buttonComponent={(onClick, styles) => (
        <span
          onClick={(e) => {
            onClick(e);
            courseTermMap?.[courseId]
              ? setCourseDesc(courseTermMap[courseId])
              : fetchCourseName();
          }}
          style={{ cursor: "pointer" }}
        >
          <EyeIcon />
        </span>
      )}
      menuComponent={(closeForm) => (
        <>
          <Card
            className="mb-0 regular-body label-color"
            style={{ borderRadius: "12px", maxWidth: "350px" }}
          >
            <div className="p-2">
              {isFetching ? (
                "Loading..."
              ) : (
                <div className="p-2 d-flex flex-column">
                  <div className="d-flex flex-shrink-0 align-items-center mb-1">
                    <div className="text-bold mr-2">Course ID:</div>
                    <div>{courseId}</div>
                  </div>
                  <div className="d-flex mb-1">
                    <div className="text-bold text-nowrap mr-2">
                      Course Name:
                    </div>
                    <div>{courseDesc || "-"}</div>
                  </div>
                  <div className="d-flex align-items-center">
                    <div className="mr-2 text-bold">Term:</div>
                    <div>{term || "-"}</div>
                  </div>
                </div>
              )}
            </div>
          </Card>
        </>
      )}
      transformOriginVertical="center"
      transformOriginHorizontal="left"
    />
  );
};

export const RemarksPopover = ({ epmrNumber, status }) => {
  const { remarksMap, setRemarksMap } = useContext(EPMRContext);

  const [remark, setRemark] = React.useState([]);
  const [isFetching, setIsFetching] = React.useState(false);

  const fetchRemarkByEpmrNumber = async () => {
    setIsFetching(true);
    if (epmrNumber) {
      const res = await getRemarksByEpmrNumber(epmrNumber);
      if (res?.code === 200 && res?.data) {
        const remarkList = res?.data.filter((item) => item?.remark);

        setRemark(remarkList);
        setRemarksMap((prev) => ({
          ...prev,
          [epmrNumber]: remarkList,
        }));

        setIsFetching(false);

        return;
      }
      setIsFetching(false);
    }
    setRemark([]);
    setRemarksMap((prev) => ({
      ...prev,
      [epmrNumber]: [],
    }));
    setIsFetching(false);
  };

  const RemarkTable = () => {
    return (
      <table>
        <thead className="text-bold">
          <td>EmpId</td>
          <td>Remark</td>
        </thead>

        {remark.map((row) => (
          <tr className="mt-2">
            <td className="pr-4 text-nowrap">{row.actionByUserId}</td>
            <td>{row.remark || "-"}</td>
          </tr>
        ))}
      </table>
    );
  };

  return (
    <APopover
      buttonComponent={(onClick, styles) => (
        <span
          onClick={(e) => {
            onClick(e);
            remarksMap?.[epmrNumber]
              ? setRemark(remarksMap[epmrNumber])
              : fetchRemarkByEpmrNumber();
          }}
          style={{ cursor: "pointer" }}
          className="text-bold text-xs text-primary"
        >
          View
        </span>
      )}
      menuComponent={(closeForm) => (
        <>
          <Card
            className="mb-0 regular-body label-color"
            style={{ borderRadius: "12px" }}
          >
            <div className="p-2">
              {isFetching ? (
                "Loading..."
              ) : remark.length ? (
                <RemarkTable />
              ) : (
                "-"
              )}
            </div>
          </Card>
        </>
      )}
      transformOriginVertical="center"
      transformOriginHorizontal="left"
    />
  );
};

export const ReceiptStatus = ({ status, isApproved }) => {
  let displayStatus = status;

  if (status && ["new", "l1_reject", "l2_reject"].includes(status))
    displayStatus = "Pending";
  else if (status === "pending" && !isApproved)
    displayStatus = "Waiting for L1 Approval";
  else if (status === "l1_approved" && isApproved) displayStatus = "Cancelled";
  else if (status === "l1_approved" && !isApproved)
    displayStatus = "Waiting for L2 Approval";
  else if (status === "l2_approved" && isApproved) displayStatus = "Cancelled";

  const { bgColor, color } = getColor(displayStatus);

  return (
    <div
      style={{
        backgroundColor: bgColor,
        width: "105px",
        maxWidth: "120px",
        padding: "0.2rem 0",
        borderRadius: "8px",
        textAlign: "center",
      }}
    >
      {displayStatus.length > 10 ? (
        <StatusPopover displayStatus={displayStatus} />
      ) : (
        <span
          style={{
            fontSize: "12px",
            color,
            textTransform: "capitalize",
          }}
        >
          {displayStatus}
        </span>
      )}
    </div>
  );
};

function getColor(status) {
  switch (status?.toLowerCase()) {
    case "confirmed":
      return { bgColor: "#BBE2CE", color: "#0B442D" };
    case "pending":
      return { bgColor: "#FFEDC8", color: "#705010" };
    case "cancelled":
      return { bgColor: "#F9D9D7", color: "#B32306" };
    default:
      return { bgColor: "#F5F5F5", color: "#262626" };
  }
}

const StatusPopover = ({ displayStatus }) => {
  return (
    <APopover
      buttonComponent={(onClick, styles) => (
        <div className="text-xs">
          <span>{displayStatus.substring(0, 7)}...</span>&nbsp;
          <span
            onClick={(e) => {
              onClick(e);
            }}
            style={{ cursor: "pointer" }}
          >
            <EyeIcon />
          </span>
        </div>
      )}
      menuComponent={(closeForm) => (
        <>
          <Card
            className="p-3 mb-0 regular-body label-color text-center"
            style={{ borderRadius: "12px" }}
          >
            <div>
              <p
                style={{
                  color: "#AFAFAF",
                  marginBottom: "2px",
                  fontSize: "12px",
                }}
              >
                Cancellation status
              </p>
              <p
                style={{
                  fontSize: "12px",
                  fontFamily: "Gilroy-Bold",
                  marginBottom: 0,
                }}
              >
                {displayStatus}
              </p>
            </div>
          </Card>
        </>
      )}
      transformOriginVertical="top"
      transformOriginHorizontal="center"
      anchorOriginHorizontal="center"
      anchorOriginVertical="bottom"
    />
  );
};
